const translations = {
  en: {
    username: 'username',
    password: 'password',
    login: 'login',
    error: 'Error',
    information: 'Information',
    errorGettingToken: 'Error getting token ',
    errorGettingTokenColon: 'Error getting token: ',
    errorGettingCustomerInfo: 'Error getting customer info: ',
    errorGettingBalance: 'Error getting balance: ',
    userPassRequired: 'Username and password required',
  },
  es: {
    username: 'usuario',
    password: 'contraseña',
    login: 'iniciar sesión',
    error: 'Error',
    information: 'Información',
    errorGettingToken: 'Error obteniendo token ',
    errorGettingTokenColon: 'Error obteniendo token: ',
    errorGettingCustomerInfo: 'Error obteniendo información del cliente: ',
    errorGettingBalance: 'Error obteniendo saldo: ',
    userPassRequired: 'Usuario y contraseña requeridos',
  },
  pt: {
    username: 'usuário',
    password: 'senha',
    login: 'entrar',
    error: 'Erro',
    information: 'Informação',
    errorGettingToken: 'Erro ao obter token ',
    errorGettingTokenColon: 'Erro ao obter token: ',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
    errorGettingBalance: 'Erro ao obter saldo: ',
    userPassRequired: 'Usuário e senha obrigatórios',
  },
}

export default translations
